<template>
  <div class="container-fluid">
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between my-2">
      <h1 class="h3 mb-0 text-gray-800">Dashboard</h1>
    </div>

    <!-- Content Row -->
    <div class="row">
      <!-- Area Chart -->
      <div class="col-xl-12 col-lg-12">
        <div class="card shadow mb-4">
          <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary">Weekly Contract Totals</h6>
          </div>
          <div class="card-body">
            <div class="chart-area">
              <AreaChart />
            </div>
          </div>
        </div>
      </div>
      <!-- Bar Chart -->
      <div class="col-xl-12 col-lg-12">
        <div class="card shadow mb-4">
          <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary">Monthly Contract Totals</h6>
          </div>
          <div class="card-body">
            <div class="chart-bar">
              <BarChart />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { defineComponent } from 'vue';
  import AreaChart from '@/components/AreaChart';
  import BarChart from '@/components/BarChart';
  import { authMixin } from '@/mixins/authMixin'; // Importar el mixin de autenticación
  import axios from 'axios';

  export default defineComponent({
    name: 'HomeView',
    components: {
      AreaChart,
      BarChart
    },
    mixins: [authMixin], // Usar el mixin de autenticación ->\src\mixins\authMixin.js

    mounted() {
      // Llamada a logUserAction solo una vez después de que el usuario haya iniciado sesión y esté en el Home
      this.checkUserIdentity().then(userId => {
        if (userId) {
          this.logUserAction('login', 'User', userId, 'User logged in successfully');
        }
      });
    },
    methods: {
      // Llamada para obtener la identidad del usuario autenticado
      async checkUserIdentity() {
        const user = await this.getAuthenticatedUser();
        return user ? user.id : null; // Retorna el ID del usuario o null
      },

      // Método para registrar la acción del usuario
      logUserAction(action, model_name, object_id, details) {
        const token = localStorage.getItem('authToken');
        if (token) {
          axios.post('/api/log-action/', {
            action,
            model_name,
            object_id,
            details
          }, {
            headers: {
              Authorization: `Token ${token}`,
              'Content-Type': 'application/json'
            }
          })
          .then(response => {
            console.log("Acción registrada:", response.data);
          })
          .catch(error => {
            console.error("Error registrando la acción:", error);
          });
        } else {
          console.error("Token no encontrado. El usuario no está autenticado.");
        }
      }
    }
  });
</script>

<style scoped>
  .chart-area,
  .chart-bar,
  .chart-pie {
    height: 400px;
  }
</style>